module.exports = __webpack_public_path__ + "static/media/Humanist777BoldCondensedBT.e09e5e23.ttf";